export default "<kt-splash-screen *ngIf=\"loader\"></kt-splash-screen>\n<router-outlet></router-outlet>\n<div id=\"global-modal-outlet\"></div>";